export const environment = {
    production: true,
    appVersion: require('../../package.json').version,
    //API_URL: 'https://api-staging.tachosafe.net/TachoSafe/',
    //CHART_API_URL: 'https://rszoft-report-staging.tachosafe.net/charts-generator-api/v0/',
    //DEVICE_QR_URL: 'https://staging.tachosafe.net/app',
    PROFILE: 0,
    PRINT_TEST: false,
    I18N_URL: 'https://i18n.tachosafe.net',
    I18N_KEY: 'tgpak_gvptiytqoe4ha4deonwdmzlonbrg23lhorsw23lbnaytg'
};

// API_URL
//      1. https://tachosafe.ro:9088/TachoSafe/-test
//      2. https://api.tacho4safe.com/TachoSafe/ - live
//      3. https://api.tachodownload.com/TachoSafe/ - TCD
//      4. https://api.hdtach.de/Hansedis/ - hanseDis -> PORT: 8093
//      + tachosafe.ro:8082/TachoSafe, https://gateway.tachosafe.ro/ - gatewaytest, tachosafe.ro:8081-updater

// PROFILES
//      1. Tacho4Safe - 0
//      2. TCD - 1
//      3. HanseDis - 2
